import React, { useState, useEffect } from "react";
import axios from "axios";

// 세션 쿠키 허용 설정
axios.defaults.withCredentials = true;

function InfoModel( ) {
    const [isEditing, setIsEditing] = useState(false);
    const [infoContent, setInfoContent] = useState("");
    const [tempContent, setTempContent] = useState("");
    const [lastModifier, setLastModifier] = useState("");
    const [lastUpdated, setLastUpdated] = useState("");
    const [userInfo, setUserInfo] = useState(null);

    // 1. JWT 토큰을 사용하여 세션 유저 정보(관리자 여부 포함) 가져오기
    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        console.log("📌 JWT 토큰:", token);

        if (token) {
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            axios.get(`${process.env.REACT_APP_SPRING_API_URL}/api/session-user`)
                .then(res => {
                    console.log("✅ 세션 유저 정보:", res.data);
                    setUserInfo(res.data);
                })
                .catch(err => {
                    console.error("❌ 세션 유저 조회 실패:", err);
                    setUserInfo(null);
                });
        } else {
            console.log("⚠ JWT 토큰 없음");
            setUserInfo(null);
        }
    }, []);

    // 2. 관리자 여부 판단 (CommentSection 방식과 통일)
    const isAdmin = userInfo && (userInfo.isAdmin === true || userInfo.admin === true);

    const fetchInfo = async () => {
        console.log("📌 fetchInfo 호출됨");

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SPRING_API_URL}/api/admin/info`
            );

            console.log("✅ 소개글 API 응답:", response.data);

            setInfoContent(response.data.content ?? "");
            setTempContent(response.data.content ?? "");
            setLastModifier(response.data.modifierName ?? "");
            setLastUpdated(response.data.updatedAt ?? "");

        } catch (error) {
            console.error("❌ 소개글 조회 실패:", error);
        }
    };

    useEffect(() => {
        console.log("📌 InfoModel 마운트됨");
        fetchInfo();
    }, []);

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("jwtToken");
            await axios.post(`${process.env.REACT_APP_SPRING_API_URL}/api/admin/info/update`,
                { content: tempContent },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            alert("수정되었습니다.");
            setIsEditing(false);
            fetchInfo(); // 수정 후 최신 데이터(수정자 포함) 다시 불러오기
        } catch (error) {
            if (error.response?.status === 403) {
                alert("관리자 권한이 없습니다.");
            } else {
                alert("저장 중 오류가 발생했습니다.");
            }
        }
    };

    return (
        <div className="info-detail" style={{ border: "2px solid black", padding: 20, width: 1000, background : "white", marginBottom: "50px" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ textShadow: "none", color: "black", margin: 0 }}>소개글</h3>

                {/* 관리자일 때만 수정 버튼 표시 */}
                {isAdmin && (
                    isEditing ? (
                        <button onClick={handleSave} style={btnStyle}>확인하기</button>
                    ) : (
                        <button onClick={() => setIsEditing(true)} style={btnStyle}>수정하기</button>
                    )
                )}
            </div>

            <hr style={{ border: "1px solid black", margin: '15px 0' }} />

            <div className="info-item-container">
                {isEditing ? (
                    <textarea
                        style={{
                            width: '100%',
                            minHeight: '300px',
                            padding: '15px',
                            border: '2px solid black',
                            fontSize: '1rem',
                            color: 'black'
                        }}
                        value={tempContent}
                        onChange={(e) => setTempContent(e.target.value)}
                    />
                ) : (
                    <>
                        <p className="info-item" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.8', color: '#333', fontSize: '1rem' }}>
                            {infoContent || "내용을 불러오는 중입니다..."}
                        </p>
                        {lastModifier && (
                            <div style={{ textAlign: 'right', marginTop: '20px', color: '#888', fontSize: '0.85rem' }}>
                                <span>최종 수정자: {lastModifier}</span>
                                <span style={{ marginLeft: '10px' }}>
                                    ({new Date(lastUpdated).toLocaleString()})
                                </span>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

const btnStyle = {
    padding: '6px 16px',
    backgroundColor: 'white',
    color: 'black',
    border: '2px solid black',
    borderRadius: '0px', // 디자인 통일을 위해 사각형 유지
    cursor: 'pointer',
    fontWeight: 'bold'
};

export default InfoModel;